import { ByoaAgent, ByoaAgentsGetApiRes } from '@/types/agent';
import { CallMethodEnums } from '@/types/api';

import { callJson } from './utils';

export const byoaAgentDelete = async( id: string ): Promise<unknown> => {
  return await callJson<undefined, unknown>( {
    isProtected: true,
    method: CallMethodEnums.DELETE,
    route: `/api/proxy/aidp-core/v2/agents/${ encodeURIComponent( id ) }`
  } );
};

export const byoaAgentsGet = async(): Promise<ByoaAgentsGetApiRes> => {
  return await callJson<undefined, ByoaAgentsGetApiRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: '/api/proxy/aidp-core/v2/agents'
  } );
};

export const byoaAgentGet = async( agentName: string ): Promise<ByoaAgent> => {
  return await callJson<undefined, ByoaAgent>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: `/api/proxy/aidp-core/v2/agents/${ agentName }`
  } );
};